import { IVictim } from "../types/common";
import { convertLocale } from "./convertLocale";
import { restoreSubmittedDate } from "./toUtcNoonISOString";

export function getDateInterval(
  victim: IVictim,
  locale: string | undefined,
): string {
  const dateLocale = convertLocale(locale);

  const birthDate = victim.birthDate
    ? restoreSubmittedDate(victim.birthDate).toLocaleDateString(
        dateLocale,
        {
          timeZone: "UTC",
        },
      )
    : "";
  const deathDate = victim.deathDate
    ? restoreSubmittedDate(victim.deathDate).toLocaleDateString(dateLocale, {
        timeZone: "UTC",
      })
    : "невід.";

  return birthDate ? `${birthDate} - ${deathDate}` : deathDate;
}
